<template>
    <img
        v-if="src"
        :src="src"
        :alt="alt"
    >
</template>

<script>
export default {
    props: ["url", "w", "h", "fit", "alt"],

    data() {
        return {
            src: null
        };
    },

    created() {
        this.$asset(
            {
                src: this.url,
                w: this.w,
                h: this.h,
                fit: this.fit
            },
            response => {
                if (!response) return;
                console.log("resposne" + response.src);
                this.src = response.src;
                this.alt = response.alt;
            }
        );

        console.log("Asset");
        console.log(this);
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Asset.vue